import { styled, Box, Button, createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_ICON,
  DARK_MODAL_BACKGROUND,
  LIGHT_MODAL_BACKGROUND,
  PLAIN_ICON,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_MODAL_BORDER,
} = COLORS;

export const MainCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_MODAL_BACKGROUND : LIGHT_MODAL_BACKGROUND,
  padding: 1,
  borderImageSlice: '1',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  border: 'none',
}));

export const ButtonCont = styled(Box)(({ theme }) => ({
  marginTop: 10,
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  gap: 10,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const SelectButton = styled(Button)(() => ({
  flex: 1,
  height: 44,
  color: COLORS.WHITE,
}));

export const CancelButton = styled(Button)(() => ({
  height: 44,
  flex: 1,
  border: `solid 1px ${PRIMARY_BUTTON_BORDER}`,
  backgroundColor: 'transparent',
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      '& .MuiSelect-icon': {
        color: (theme.palette.type === 'dark' ? PLAIN_ICON : DARK_ICON) + '!important', // Change this to your desired color,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 10,
        height: 35,
      },
    },
    popoverBox: {
      boxShadow: 'none',
      border: '3px solid',
      borderColor: PRIMARY_MODAL_BORDER,
      borderRadius: 8,
      width: '100%',
    },
    title: {
      textAlign: 'center',
      marginTop: 20,
      fontSize: 24,
      fontWeight: 700,
      [theme.breakpoints.down('md')]: {
        fontSize: 18,
      },
    },
    subtitle: {
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
      },
    },
    mediaAttached: {
      fontSize: 16,
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
      },
    },
    viewMediaButton: {
      marginLeft: 10,
      border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
      backgroundColor: 'transparent',
      [theme.breakpoints.down('md')]: {
        fontSize: 10,
        padding: 5,
      },
    },
  }),
);
